import React from 'react';
import { H2, P, UL, LI, Callout, FeatureLink } from './_shared';

export default {
  slug: 'compliance',
  title: 'Compliance checklist',
  category: 'folders',
  summary: 'Required-doc checklists per jurisdiction, broker review queue, and 7-year retention.',
  searchTerms: ['compliance', 'checklist', 'audit', 'retention', 'broker review'],
  related: ['folder-lifecycle', 'broker-dashboard'],
  Body: () => (
    <>
      <P>
        Every folder shows a compliance checklist tailored to your state and
        deal type. Items tick green automatically as you upload matching
        docs; what's left is what your broker would otherwise have to chase
        you for.
      </P>

      <H2>How the checklist is built</H2>
      <P>
        Required-doc lists are seeded per jurisdiction (Illinois ships
        first; Lone Wolf partnership extends to all 50 states in V2.5).
        Your brokerage admin can add custom items (e.g. "company-specific
        wire-fraud notice") in Settings → Compliance Templates.
      </P>

      <H2>Broker review</H2>
      <P>
        When a folder hits <em>pending_review</em>, it lands in the broker's{' '}
        <FeatureLink to="/broker/audit">Audit queue</FeatureLink>. The broker
        sees the checklist, the doc previews, and the activity feed, and
        either Approves (folder → closed) or Returns with comments.
      </P>

      <H2>Retention</H2>
      <P>
        Closed folders stay searchable for 7 years (the standard real-estate
        record-retention window). After 7 years they auto-archive — still
        recoverable by compliance, but no longer surfaced in agent search.
      </P>

      <Callout kind="warn">
        Deleting a folder isn't really possible from the agent UI. That's by
        design — real-estate records must survive personnel changes. If you
        created a folder by mistake, mark it "void" with a reason; it stays
        in the audit log.
      </Callout>
    </>
  ),
};
